import { AtividadeProgramaDTO } from "./atividadeProgramaDTO";

export class TreinoProgramaDTO {
    id: number;
    idprograma: number;
    descricao: string;
    ordem: number;
    semana: number;
    dia: number;

    programaAtividade: Array<AtividadeProgramaDTO>;
}